// extracted by mini-css-extract-plugin
export default {"content":"jLW2ttpAdIUcnqCk8oTj","loader":"p4Ta0CoFJM7vC9vJ7NIE"};